"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _GridContainer = _interopRequireDefault(require("../GridContainer/GridContainer"));
var _ResponsiveDisplay = _interopRequireDefault(require("../../../foundations/ResponsiveDisplay/ResponsiveDisplay"));
var _excluded = ["children"],
  _excluded2 = ["children"];
var _templateObject, _templateObject2;
var GridStyles = (0, _styledComponents.default)(_Grid.default)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  /* max-width: 1440px; */\n  /* width: 100%; */\n\n.MuiGrid-container {\n  /* width: 100%; */\n  }\n"])));
var ItemStyles = (0, _styledComponents.default)(_Grid.default)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  /* p {\n    background-color: var(--bf-core-teal, teal);\n    color: var(--bf-core-white, teal);\n  } */\n  background-color: ", ";\n"])), function (props) {
  return props.gridColor;
});
function SingleColumn(_ref) {
  var children = _ref.children,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var Singular = _react.default.createElement(ItemStyles, Object.assign({
    item: true
  }, props), " ", children, " ");
  return _react.default.createElement(_ResponsiveDisplay.default, Object.assign({
    componentToDisplay: Singular
  }, props));
}
function TwelveColumnGrid(_ref2) {
  var children = _ref2.children,
    props = (0, _objectWithoutProperties2.default)(_ref2, _excluded2);
  return _react.default.createElement(_GridContainer.default, props, _react.default.createElement(GridStyles, Object.assign({
    container: true,
    spacing: 1,
    justifyContent: "center",
    alignContent: "center",
    alignItems: "center",
    direction: props.flipped ? 'row-reverse' : 'row'
  }, props), children));
}
TwelveColumnGrid.Item = SingleColumn;
var _default = TwelveColumnGrid;
exports.default = _default;